export enum DatadogEnvironment {
  DEV = 'dev',
  STAGING = 'staging',
  PRODUCTION = 'production',
}
